/*CreateActionCreator()
Outer:
    Parameters:
        type: the action type
    Returns:
        An action creating function

Inner:
    Parameters:
        payload: the "body" of the action (data needed to perform the action)

    Returns:
        An action object consisting of the outer type and the inner payload
*/

export const createActionCreator = type => payload => ({ type, payload });
